import React, { useState, useEffect } from "react";
import API_BASE_URL from "../../config";
import NavBar from "../NavBar";
import placeholderImg from "../../Assets/logo_rm.png";
import "../Styles/BoardMembers.css";

const BoardMembers = () => {
    const [boardData, setBoardData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBoardMembers = async () => {
            try {
                const res = await fetch(`${API_BASE_URL}/api/board`);
                const data = await res.json();
                if (data.success) {
                    // Group members by section
                    const grouped = data.data.reduce((acc, member) => {
                        const section = acc.find(s => s.section === member.section);
                        if (section) {
                            section.members.push(member);
                        } else {
                            acc.push({ section: member.section, members: [member] });
                        }
                        return acc;
                    }, []);

                    // Maintain a specific section order if needed
                    const orderMap = {
                        "Executive Board - Incharge Lecturer": 1,
                        "Executive Board": 2,
                        "Pillar Heads": 3
                    };

                    grouped.sort((a, b) => (orderMap[a.section] || 99) - (orderMap[b.section] || 99));

                    // Sort members within each section by their 'order' value
                    grouped.forEach(section => {
                        section.members.sort((a, b) => (a.order || 0) - (b.order || 0));
                    });

                    setBoardData(grouped);
                }
            } catch (error) {
                console.error("Error fetching board members:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchBoardMembers();
    }, []);

    const getImageUrl = (imagePath) => {
        if (!imagePath) return placeholderImg;
        if (imagePath.startsWith("http")) return imagePath;
        return `${API_BASE_URL}/${imagePath.replace(/\\/g, "/")}`;
    };

    return (
        <div className="board-page">
            <div className="board-header-section">
                <NavBar />
                <header className="board-header">
                    <div className="header-content">
                        <h1 className="board-title">Board Members</h1>
                        <p className="board-year">2025 / 2026</p>
                        <div className="header-divider"></div>

                    </div>
                </header>
            </div>

            <main className="board-content">
                {loading ? (
                    <div className="loading-state">
                        <div className="loader"></div>
                        <p>Loading board structure...</p>
                    </div>
                ) : boardData.length === 0 ? (
                    <div className="empty-state">No board members found.</div>
                ) : (
                    boardData.map((section, index) => (
                        <section key={index} className="board-section">
                            <div className="section-header">
                                <h2 className="section-title">{section.section}</h2>
                                <div className="section-line"></div>
                            </div>
                            <div className="members-grid">
                                {section.members.map((member, idx) => (
                                    <div
                                        key={idx}
                                        className="member-card"
                                        style={{ '--role-color': member.roleColor || '#3b82f6' }}
                                    >
                                        <div className="card-top-line"></div>
                                        <div className="member-photo-container">
                                            <div className="photo-border-glow"></div>
                                            <img
                                                src={getImageUrl(member.image)}
                                                alt={member.name}
                                                className="member-photo"
                                                onError={(e) => { e.target.src = placeholderImg; }}
                                            />
                                        </div>
                                        <div className="member-info">
                                            <h3 className="member-name">{member.name}</h3>
                                            <div className="member-position">{member.position}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>
                    ))
                )}
            </main>
        </div >
    );
};

export default BoardMembers;
